const KEY = 'udv-prefer-fullscreen'

/** PWA instalada (iOS standalone, display-mode standalone/fullscreen, Android TWA). */
export function isPwaStandalone() {
  if (typeof window === 'undefined') return false
  if (window.navigator.standalone === true) return true
  try {
    if (window.matchMedia('(display-mode: standalone)').matches) return true
    if (window.matchMedia('(display-mode: fullscreen)').matches) return true
  } catch (e) {
    /* ignore */
  }
  if (typeof document !== 'undefined' && document.referrer.includes('android-app://')) {
    return true
  }
  return false
}

export function getPreferFullscreen() {
  try {
    return window.localStorage.getItem(KEY) === '1'
  } catch (e) {
    return false
  }
}

export function setPreferFullscreen(value) {
  try {
    if (value) {
      window.localStorage.setItem(KEY, '1')
    } else {
      window.localStorage.removeItem(KEY)
    }
  } catch (e) {
    /* ignore */
  }
}

/** PWA: pantalla completa activada por defecto (persiste entre sesiones). */
export function ensurePwaFullscreenDefault() {
  if (!isPwaStandalone()) return
  setPreferFullscreen(true)
}

/** @returns {Promise<void>} */
export async function exitDocumentFullscreen() {
  if (typeof document === 'undefined') return
  try {
    if (document.exitFullscreen) {
      await document.exitFullscreen()
    } else if (document.webkitExitFullscreen) {
      await document.webkitExitFullscreen()
    }
  } catch (e) {
    /* ignore */
  }
}

/** @returns {Promise<boolean>} */
export async function requestDocumentFullscreen() {
  if (typeof document === 'undefined') return false
  const elem = document.documentElement
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

  if (document.fullscreenElement || document.webkitFullscreenElement) {
    return true
  }

  try {
    if (isIOS) {
      if (elem.webkitEnterFullscreen) {
        await elem.webkitEnterFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        await elem.webkitRequestFullscreen()
      } else {
        return false
      }
    } else if (elem.requestFullscreen) {
      await elem.requestFullscreen()
    } else {
      return false
    }
    return !!(document.fullscreenElement || document.webkitFullscreenElement)
  } catch (e) {
    return false
  }
}
